export let safarimovies = [
    // {
    //     "id" : 1,
    //     "contents" : 11,
    //     "name" : "Arabic Movies",
    //     "videos" : [
    //         {
    //             "duration" : "Watch Now",
    //             "id" : "arabic-movies-1",
    //             "name" : "7alawet Roo7",
    //             "preview" : "./img/movies/arabic-movies/7alawet-roo7.jpg",
    //             "desc" : "تدور قصة الفيلم حول روح (هيفاء وهبي) التي تعيش بحي (بولاق الدكرور) برفقة والدة زوجها أم فاروق حيث أن زوجها مسافر خارج البلاد. تتعرض روح للعديد من المتاعب بسبب جيرانها. بخاصة من جارها الذي يطمع في الحصول عليها، بالإضافة إلى محاولات شخص أخر يقوم بالضغط عليها بكافة السبل المشروعة وغير المشروعة من أجل الحصول عليها لكنها تقف له بالمرصاد. يتم نصب فخ لها على يد اثنان من جيرانها (باسم سمرة) و(محمد لطفي) من أجل تحقيق أطماعهما."
    //         },
    //         {
    //             "duration" : "Watch Now",
    //             "id" : "arabic-movies-2",
    //             "name" : "Shad Ajza2",
    //             "preview" : "./img/movies/arabic-movies/shad-ajza2.jpg",
    //             "desc" : "في إطار حركي، تدور أحداث الفيلم حول ضابط الشرطة عمر العطار (محمد رمضان) الذي يتعرض لموقف يقلب حياته المهنية والشخصية رأسًا على عقب، عندما يتم قتل زوجته آية (دنيا سمير غانم) على يد إحدى العصابات، فيسعى للثأر لها، وهو الأمر الذي يدخله في سلسلة من المشكلات المتتالية مع رؤساءه، ويصبح مطاردًا من قبل قوات الأمن."
    //         },
    //         {
    //             "duration" : "Watch Now",
    //             "id" : "arabic-movies-3",
    //             "name" : "7amati Bet7ebni",
    //             "preview" : "./img/movies/arabic-movies/7amati-bet7ebni.jpg",
    //             "desc" : "تدور أحداث الفيلم حول أحد الشباب (حمادة هلال) ، الذي يعمل طبيب تجميل ، يقع في العديد من المشاكل بسبب حبه الشديد للنساء ، قبل أن يقرر الخضوع للعلاج النفسي ، وتتوالى الأحداث إلى أن تكتشف طبيبته النفسية (ميرفت أمين) أنه على علاقة بابنتها (إيمان العاصي) ، فتحاول الوقوف أمام استمرار هذه العلاقة بشتى الطرق الممكنة."
    //         },
    //         {
    //             "duration" : "Watch Now",
    //             "id" : "arabic-movies-4",
    //             "name" : "3eyal 7arrifa",
    //             "preview" : "./img/movies/arabic-movies/3eyal-7arrifa.jpg",
    //             "desc" : "يعمل سباعي مكرونة (محمد لطفي) مدربًا لكرة القدم في نادي الدقي الرياضي، لكنه لا يفلح في صنع أي انجازات تذكر في مسيرته، وهو ما يجعل حبشي غير موافق على زواجه من ابنته أوشا (بوسي)، لكن تتبقى له فرصة أخيرة لاثبات ذاته، وهو أن يتولى مسئولية تدريب فريق كرة القدم النسائية، لكنه يكتشف الكثير من التلاعب والفساد من قبل أحد النافذين في إتحاد كرة القدم."
    //         },
    //         {
    //             "duration" : "Watch Now",
    //             "id" : "arabic-movies-5",
    //             "name" : "3omar w Salma 3",
    //             "preview" : "./img/movies/arabic-movies/3omar-w-salma-3.jpg",
    //             "desc" : "فى هذا الجزء يستمر عمر فى تصرفاته الطائشة وعدم العمل فى وظيفة، ويقرر العمل كمطرب شعبى وترفض سلمى ذلك وترفض ايضا ملاحقته للبنات. فتقرر خلعه وتنجح فى ذلك بمساعدة بناتهما؛ فيقرر عمر عقابها بادعائه خطوبة فتاة على درجة عالية من الجمال، واختطاف البنتين لتأديب سلمى. فتكون المفاجأة ان والد عمر قد لقن الاثنين درسا حتى لا يتلاعبان بالطلاق والخلع مرة اخرى."
    //         },
    //         {
    //             "duration" : "Watch Now",
    //             "id" : "arabic-movies-6",
    //             "name" : "3shan 5arjeenv",
    //             "preview" : "./img/movies/arabic-movies/3shan-5arjeenv.jpg",
    //             "desc" : "رمزي الدسوقي شاب مستهتر في علاقاته النسائية، يقرر رئيسه في العمل تعريفه على ابنته ليلى مراد بغرض تزويجها منه والخلاص من مشاكلها التي لا تنتهي، ومع لقائهما، يترك رجل مجهول حقيبة مليئة باﻷموال على طاولتهما، وهو ما يدخلهما في سلسلة لا تنتهي من المطاردات والمغامرات الكوميدية مع صاحب الحقيبة."
    //         },
    //         {
    //             "duration" : "Watch Now",
    //             "id" : "arabic-movies-7",
    //             "name" : "7amlet Frezer",
    //             "preview" : "./img/movies/arabic-movies/7amlet-frezer.jpg",
    //             "desc" : "تتبدل الحالة المناخية لمصر لتتحول إلى صقيع تام، ويقرر مجموعة من ضباط المخابرات السفر إلى إيطاليا في مهمة للحصول على جهاز يمتلك القدرة على إيقاف الصقيع، وينتحلوا شخصيات فريق عمل سينمائي لكي يتظاهروا بتصوير فيلم، ويتعاملوا مع ممثل فاشل يدعى مديح البلبوصي، كما يتعاونوا مع فتاة لديها سوابق في اﻵداب تدعى تباهي."
    //         },
    //         {
    //             "duration" : "Watch Now",
    //             "id" : "arabic-movies-8",
    //             "name" : "Ahwak",
    //             "preview" : "./img/movies/arabic-movies/Ahwak.jpg",
    //             "desc" : "شريف قابيل (تامر حسني) طبيب متخصص في جراحات التجميل، يتعرف عن طريق شقيقته نجوى على شابة صغيرة في السن تدعى بسنت ويعجب بها، ولكنه عندما تسنح له الفرصة لمقابلة والدتها العزباء رنا (غادة عادل) والتواجد معها في نفس المكان لفترة، يزداد إعجابه بالأم، فيحاول طيلة الوقت أن يوقعها في حبه خلال تواجده معها بالغردقة بدعوة من الابنة."
    //         },
    //         {
    //             "duration" : "Watch Now",
    //             "id" : "arabic-movies-9",
    //             "name" : "Bonne Soiree",
    //             "preview" : "./img/movies/arabic-movies/Bonne-Soiree.jpg",
    //             "desc" : "يدور الفيلم حول قضية الميراث، من خلال ثلاث فتيات، خريجة حقوق واختها خريجة دار العلوم وأخرى نرجسية تركت دراستها بكلية التجارة وتزوجت وفشلت ووالدهن. حيث يرثن تركة كبيرة عبارة عن كباريه يدعى بون سواريه, وتتولى اثنتان منهن (غادة عبد الرازق ونهلة ذكي) ادارته بسعادة، حيث يحقق لهما نقلة نوعية على المستوى المادي، وسط اعتراض ونصيحة أختهما الثالثة المتدينة (مي كساب) بأن يتخلصا من هذا الملهى الليلي، إلا أنهما عنيدتان وترفضان تقبل نصيحتها، بل وتقدم كل منهما فقرة في هذا الكباريه. ونتيجة دخولهما هذا العالم الجديد عليهما تتعرضان لمشاكل كثيرة، تنتهي بتركهما هذا المكان والبحث عن عمل شريف."
    //         },
    //         {
    //             "duration" : "Watch Now",
    //             "id" : "arabic-movies-10",
    //             "name" : "Samir Abu El Neel",
    //             "preview" : "./img/movies/arabic-movies/Samir-Abu-El-Neel.jpg",
    //             "desc" : "في إطار كوميدي تدور أحداث الفيلم حول الشاب البخيل سمير أبو النيل (أحمد مكي) الذي يقطن بحي شعبي، ونتيجة لبخله الشديد تقع له العديد من المفارقات والمشاكل مع أهل منطقته، ويزيد من كرههم له لسوء معاملته لهم، وبين ليلة وضحاها يمرض ابن عمه حسين أبو النيل (حسين اﻹمام) ويقرر أن يترك ثروته لسمير الذي يستغل ذلك ويقوم بإنشاء قناة فضائية يناقش فيها أحواله وعلاقاته بأصدقائه وأهل منطقته.. تتوالى الأحداث في سياق كوميدي بعد إنشاء حزب سياسي يدعو له المواطنين."
    //         },
    //         {
    //             "duration" : "Watch Now",
    //             "id" : "arabic-movies-11",
    //             "name" : "Zanget Setat",
    //             "preview" : "./img/movies/arabic-movies/Zanget-Setat.jpg",
    //             "desc" : "(على منير الجحش) شاب ثري يتصيد الفتيات، وخاصة من أولئك اللاتي يزرن العيادة النفسية لأبيه زير النساء هو الآخر، وبعد خلاف (علي) مع والده حول إحدى المريضات، يدخل كلاهما في رهان على مصنع يملكه الأب في (انجلترا)، حيث يتوجب عليه أن يساعد مريضا لديه بالشفاء من عقدته مع النساء بأن يخدع ثلاث فتيات تعرف عليهن المريض ورفضوا حبه، وهن: (سهام بدر)، و(شكرية تورتة)، و(سميحة العو)"
    //         },
    //
    //     ]
    // },
    {
        "id" : 2,
        "contents" : 11,
        "name" : "Documentaries",
        "videos" : [
            {
                "duration" : "Watch Now",
                "id" : 17,
                "name" : "Inside the Milky Way",
                "preview" : "./img/movies/documentaries/Inside-the-Milky-Way.jpg",
                "desc" : "نظامنا الشمسي يقع على مشارف مدينة سماوية واسعة، مجتمع ضخم من النجوم المرتبطة مع بعضها بقوانين الجاذبية فيما بعرف بمجرة درب الحليب. في يومنا هذا، يحاول علماء الفلك بالتعاون مع بعضهم البعض تفكيك الأحجية التي ستسمح لهم برؤية مجرتنا بطريقة جديدة ومثيرة للاهتمام تسمح بنا بأن نأخذ كوكبنا \"الأرض\" في رحلة مذهلة في مجاهل الفضاء الخارجي والزمن، كي نرى كيف تبدو الأحياء الأخرى المختلفة من مدينتنا النجمية الواسعة لو قمنا بزيارتها عن قرب!؟مصور ومعد باحتراف وأناقة، ومن خلال تلك المقابلات الودية مع العلماء الذين سيكشفون لنا متعة اكتشاف المفاهيم العلمية، سيروي لنا هذا العمل المتميز قصة مجرتنا بطريقة واضحة وسلسة وفوق كل ذلك ممتعة ومثيرة، فيما يلقي لنا نظرة ثاقبة على كيف تكونت -هي وكل ما فيها - مجرة درب الحليب."
            },
            {
                "duration" : "Watch Now",
                "id" : 18,
                "name" : "Interfaces - Our Digital Life",
                "preview" : "./img/movies/documentaries/Interfaces---Our-Digital-Life.jpg",
                "desc" : "لقد أصبح من شبه المستحيل أن يعمل أي شيء في يومنا هذا من دون الحواسيب. بشكل عملي، الحواسيب تتحكم في كل شيء عن طريق الشبكات، الاتصالات، وبروتوكولات إرسال واستقبال اي شيء رقمي. عالمنا يصبح شيئا فشيئا تحت سيطرة المعالجة الحسابية والبرامج. هذا الانتشار الرقمي الذي تغلغل في مفاصل حياتنا، لا يزال مستمرا في النمو أكثر فأكثر ولن يمر وقت طويل، على سبيل المثال، قبل أن تصبح كل الأجهزة المنزلية معتمدة على تكنولوجيا التحكم الرقمي بالكامل، أو حتى تغزو شوارع كاليفورنيا أول سيارة تقود نفسها ذاتيا في عام 2018. كم من \"الرقمنة\" تحتاج البشرية؟ وكم من \"الأنسنة\" تحتاج الحياة الرقمية؟ يضيء لنا هذا العمل الوثائقي المميز مختلف جوانب البيئة الرقمية ويروي لنا قصتها من خلال أربعة أجيال مختلفة مرت بها التكنولوجيا الرقمية.."
            },
            {
                "duration" : "Watch Now",
                "id" : 19,
                "name" : "Open Skies",
                "preview" : "./img/movies/documentaries/Open-Skies.jpg",
                "desc" : "ما الذي قد يكون مثيراً أكثر من التحليق إلى أراض بعيدة وغامضة؟ ماذا لو أن هذه الرحلة تخللتها مناظر مذهلة من الأعلى للطبيعة الخلابة في الأسفل، متبوعة بمقابلات استثنائية مع سكان تلك المناطق المذهلة؟ من اللقطات الجوية التي تخطف الأنفاس للمساحات الخلابة من الطبيعة مترامية الأطراف إلى تلك اللقاءات والمقابلة مع الناس الذين يشغلونها ويعيشون فيها، هذا البرنامج الفريد في فكرته يأخذنا بشكل مقرب إلى ست أماكن مختلفة من العالم: المغرب، آيسلند، كامبوديا، الأردن، نيوزيلند وتونس ليكشف لنا هذه الأرواح والشخصيات المذهلة التي تشغل هذه الأماكن والعوالم البديعة."
            },
            {
                "duration" : "Watch Now",
                "id" : 20,
                "name" : "China and the Change in the Global System",
                "preview" : "./img/movies/documentaries/China-and-the-Changes-in-the-Global-System.jpg",
                "desc" : "مقابلة حصرية من جزئين مع الدبلوماسي الفرنسي المتخصص في الشؤون الصينية ليونيل فيرون ، تتناول المقابلة الصين والتغيرات التي تطال النظام العالمي، في ظل تراجع القوة الأميركية. يطلعنا فيرون على رؤيته لتحول النظام العالمي، وتشكل أقطاب جديدة قادرة على منافسة الولايات المتحدة، مستنداً إلى تجربته الكبيرة في كواليس الدبلوماسية الفرنسية، كما يناقش تأثير الولايات المتحدة على تقارب الصين وروسيا. تنعكس التغيرات العالمية هذه على الشرق الأوسط الذي يعيش صراعاً غير بعيد عن تدخلات الدول الكبرى"
            },
            {
                "duration" : "Watch Now",
                "id" : 21,
                "name" : "Coca Cola - The Secret Formula",
                "preview" : "./img/movies/documentaries/Coca-Cola---The-Secret-Formula.jpg",
                "desc" : "ترويجاً لشعارها الأحمر والأبيض، تبيع شركة كوكاكولا حوالي المليار والنصف المليار عبوة شراب غازي يومياً. هدف الشركة هو مضاعفة تلك الانتاجية في حلول العام ألفين وعشرين. تنبع قصة النجاح هذه على سر، وهي تركيبة مميزة تم ابتكارها في العام ألف وثمانمئة وستة وثمانون من قبل صيدلي أميركي في أتلانتا، سر قامت شركة الكوكاكولا بحفظه حتى يومنا هذا. ماذا يخبئ هذا السر؟"
            },
            {
                "duration" : "Watch Now",
                "id" : 22,
                "name" : "Jordania 2000 years of History",
                "preview" : "./img/movies/documentaries/Jordania-2000-years-of-History.jpg",
                "desc" : "عرف الموقع منذ إحتلاله في العصر الحجري الحديث \"النيوليتي\"، وتأسس للمرة الأولى على يد السلوقيين أي في العصر الهنلستي. ويعرف أن السلوقيين هم قدامى المحاربين في جيش اسكندر الكبير الذي- وفقا للأسطورة- كان قد غزا سوريا وأطلق على الموقع اسم \"جرسا\". سيطر الأنباط على جراسا، ومن ثم اليهود، فخضعت بذلك للحكم الروماني. وبعد أن غزاها القائد الروماني بومبي عام 63 قبل الميلاد، سقطت المدينة في أيدي الرومان، ومع دخولها في حلف \"الديكابوليس\" أصبحت واحدة من المدن العشرة الأساسية في الأمبراطورية الرومانية. وقد نمت ثروة جرش بفضل أعمالها التجارية وأنشطتها الزراعية في منطقة البحر الأبيض المتوسط. لكنها بلغت ذروتها في القرن الثاني أي في عهد الامبراطور هادريان الذي قضى فيها فترة من العام 129 ميلادي.شيد هارديان عدداً من مشاريع البناء مثل البوابة الجنوبية، وقوس النصر، ومعبد الإله آرتيموس الذي لايزال يحتفظ ببصمته المدهشة إلى يومنا هذا الأمر الذي جعل جرش ثاني أهم مدينة في المحافظة. وبحلول القرن الرابع إنتشرت الديانة المسيحية، فدخلت جرش لاحقاً في مرحلة جديدة من التطور حيث إنتعشت حركة تشييد الكنائس. في القرن السادس أي في عهد الإمبراطور جستنيان بنيت مجموعة من المباني منها الكاتدرائية، وكنسية القديسان كوزموس وداميان، وكنسية القديس يوحنا المعمدان، وكنسية القديس جورج، وكنيسة سانت تيودور وكلها تقع على مقربة من معبد أرتميس. إلا أن غزو الفرس والعرب ثم الأمويين تسبب بتراجع جرش.  وتبع ذلك ضربات من الزلازل المتلاحقة التي بدأت في القرن الثامن عشر وانتهت في القرن الثاني عشر مع نهاية الحروب الصليبية . وهكذا كانت جرش في حالة من الخراب وبقيت أنقاضها مطمورة في  التراب لكن آثارها بقيت شاهدة على عظمتها لقرون على الرغم من مرور الزمن."
            },
            {
                "duration" : "Watch Now",
                "id" : 23,
                "name" : "Mediterranean Sub II",
                "preview" : "./img/movies/documentaries/Mediterranean-Sub-II.jpg",
                "desc" : "في هذه الرحلة نزور أكثر الأماكن المدهشة في البحر الأبيض المتوسط، ولكن هذه المرة إننا نصور بتقنية الـHD، سمك الإنش، الباراكودا، الانقليس، ثعابين البحر، أسماك الشِفنين العُقابيّ... معًا إضافة إلى العديد من الحيوانات الصغيرة الأخرى، التي لا تقل عنها جمالًا وإثارة للدهشة، مثل الدود البزاق، والروبيان ... حيوانات استعمارية مذهلة مثل المزقييات، ومرجان البحر الأبيض المتوسط​​، والمرجان الأحمر، والمرجان الأسود.... نغوص في عالم المروج والكهوف وحطام السفن، والمنحدرات ... بحر كان أصل الحضارات ومهد القدم والثقافة ومسكن أنواع مختلفة من الحيوانات البحرية. الحمامات الرومانية في (باموكال)، (تركيا)، والصيادين مع فخاخ جراد البحر في (أوستيكا)، (إيطاليا)، وآخر الفقمات المتبقية في (زاكينثوس)، (اليونان) هي أمثلة عن عجائب التقينا بها في هذه الرحلة... كل هذا وأكثر من ذلك بكثير في 26 حلقة مصورة بتقنية الـHD."
            },
            {
                "duration" : "Watch Now",
                "id" : 24,
                "name" : "Nile's Sunken Treasures",
                "preview" : "./img/movies/documentaries/Nile's-Sunken-Treasures.jpg",
                "desc" : "على بُعد ثلاثمائة كيلومتر جنوبي القاهرة تقع مدينة أسوان بسكانها المئتي والخمسين ألفاً. هنا يدخل النيل مصر بعد رحلته الطويلة من أعماق أفريقيا. مصر هبة النيل...لقد جعلها النهر غنية وقوية. إنه أقدم طريق سفر في تاريخ البشرية. من شِبه المؤكد أنّ هناك كنوزاً أثرية غارقة في قعر النيل. سُفن بحمولتها الثمينة. لكن لم يقم أحدٌ من علماء الآثار بسبر أغوار مياه النهر...إلى حين بدء هذه المغامرة."
            },
            {
                "duration" : "Watch Now",
                "id" : 25,
                "name" : "Of Sharks and Men",
                "preview" : "./img/movies/documentaries/Of-Sharks-and-Men.jpg",
                "desc" : "حتى في القرن الحادي عشر، ما زال أمامنا أمور كثيرة لنتعلمها عن عالمنا. تجذب أساطير البحر الإنسان، فينطلق في كل يوم ليستكشفها، ويقترب قدر المستطاع من أسماك القرش الكبيرة، هذه الحيوانات المفترسة المذهلة التي تحرّك أعمق مشاعر الخوف فينا. تتميز هذه الحيوانات الموجودة منذ عصور بسلوك غالباً ما يفتقر إلى تفسير، وهذا ما أثار فضول العلماء في أنحاء العالم كافة، فوضعوا هذه الحيوانات تحت مراقبة مكثفة منذ الحرب العالمية الثانية. أما الرجل الوحيد الذي قرّر أن يقترب منها فهو \"غراهام دوين\"، فكان على مسافة قصيرة منها من دون وسائل حماية. وكان وجهاً لوجه مع مفترسيْن خارقيْن سنتمكّن من خلالهما أن نتعرف إلى القرش الكبير الذائع الصيت. لذلك، قبل أن تختفي أسماك القرش وتذهب ضحية البشر، آن الأوان اليوم لنتغلّب على مخاوفنا ونتعلم قدر المستطاع عن هذه الحيوانات الضخمة المكتنفة بالأسرار."
            },
            {
                "duration" : "Watch Now",
                "id" : 26,
                "name" : "Voyage of the Continents",
                "preview" : "./img/movies/documentaries/Voyage-of-the-Continents.jpg",
                "desc" : "خلال مليارات الكثيرة من السنين في تاريخ الأرض، لم يتوقف كوكبنا عن تغيير شكله حيث أن قوة الصفائح التكتونية الهائلة قد صقلت وأعادت تشكيل عالمنا مراراً وتكراراً في رحلة لا نهائية.. لطالما خلقت الصفائح التكتونية الحياة على الأرض، ودمرتها أيضاً، فمن براكين هائلة إلى زلازل مدمرة، لا تزال حركات هذه الصفائح تهيمن على التاريخ البشري. هذه قصة دراما متقنة وجمال رفيع عن التفاعل مابين الجيولوجيا والحياة، إنها حقيقةً رحلة القارات!"
            },
            {
                "duration" : "Watch Now",
                "id" : 27,
                "name" : "Voyage to the Deep",
                "preview" : "./img/movies/documentaries/Voyage-to-the-Deep.jpg",
                "desc" : "إن المحيطات تتغير بفعل تأثير تغير المناخ وممارسات الإنسان. حقيقة واحدة تؤكد على خطورة هذا التغيير: الأنواع الغازية، تلك التي تستعمر المساكن الطبيعية التي لا تعود لها، والآخذة في التزايد في جميع أنحاء العالم. ويعتبر الاتحاد العالمي للطبيعة الأنواع الغريبة الغازية واحدة من أكبر الأسباب الحالية لفقدان التنوع البيولوجي في العالم، وتشير إلى الخسائر الاقتصادية الفادحة حيث تتواجد. يتبع هذا الفيلم الوثائقي ستة من هذه الأنواع في محيطات مختلفة. الأسماك في جزر الكناري التي تعيش الآن في \"كابو دي بالوس\"، طحالب بحر الكاريبي التي تظهر في \"السيشيل\"، سمك موسى بحر الأبيض المتوسط ​​الذي يتكيف للعيش في \"المكسيك\" ويطرد أسماك الشبر الأصلية، نجم البحر الذي ازدادت أعداده فجأة ويهدد الشعاب المرجانية في \"تاهيتي\"... في هذا الفيلم الوثائقي الرائع، نزور أيضًا تلك البلدان بطريقة ممتعة وسهلة، ونكتشف أماكن جديدة وأساليب حياة جديدة."
            },

        ]
    },
    // {
    //     "id": 3,
    //     "contents": 8,
    //     "name": "Arabic Entertainment",
    //     "videos": [
    //         {
    //             "id": "arab-enter-hayda-1",
    //             "name": "Hayda 7aki",
    //             "desc": "Weekly comedy-oriented talk and variety show in which Adel Karam hosts guests to often reveal the funny side of their personality.",
    //             "preview": "./img/movies/arabic-entertainment/hayda-7aki.jpg",
    //             "videoUrl": "",
    //             "duration": 1,
    //             "categoryId": 7,
    //             "subCategory":
    //                 [
    //                     {
    //
    //                         "id": "arab-enter-hayda-2",
    //                         "name": "3al 3ein",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/3al-3ein.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-3",
    //                         "name": "3ala remch 3younha",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/3ala_remch_3younha.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-4",
    //                         "name": "3ali Lkoufiyi",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/3ali_Lkoufiyi.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-5",
    //                         "name": "3endak bahriya",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/3endak_bahriya.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-6",
    //                         "name": "3endak Hiwaye",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/3endak-Hiwaye.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-7",
    //                         "name": "3omri btada",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/3omri_btada.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-8",
    //                         "name": "3tazalt Al gharam",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/3tazalt_Al_gharam.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-9",
    //                         "name": "Abouki min",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Abouki_min.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-10",
    //                         "name": "Ah Ya helou",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Ah-Ya_helou.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-11",
    //                         "name": "Alef W Miyeh",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Alef-W-Miyeh.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-12",
    //                         "name": "Amantelak lesh Tkhoun",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Amantelak_lesh_Tkhoun.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-13",
    //                         "name": "Amenli bayt",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Amenli_bayt.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-14",
    //                         "name": "Ana albi lk Mayal",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Ana_albi_lk_Mayal.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-15",
    //                         "name": "Arabiyon Ana",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Arabiyon-Ana.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-16",
    //                         "name": "Asamina",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Asamina.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-17",
    //                         "name": "Awel Mara",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Awel-Mara.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-18",
    //                         "name": "Bahebak AHH",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Bahebak-AHH.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-19",
    //                         "name": "Baheb Fgharamak",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Baheb_Fgharamak.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-20",
    //                         "name": "Bektob Esmak",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Bektob_Esmak.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-21",
    //                         "name": "Helef Amar",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Helef_Amar.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-22",
    //                         "name": "Kifon habayebna",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Kifon_habayebna.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-23",
    //                         "name": "La3youni Gharibi",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/La3youni_Gharibi.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-24",
    //                         "name": "Libnan",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Libnan.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-25",
    //                         "name": "Mama ya Mama",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Mama_ya_Mama.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-26",
    //                         "name": "Mawal Emmi",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Mawal_Emmi.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-27",
    //                         "name": "Men hawn",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Men_hawn.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-28",
    //                         "name": "Sabaya Bladi",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Sabaya_Bladi.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-29",
    //                         "name": "Wala Mara",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Wala_Mara.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     },
    //                     {
    //                         "id": "arab-enter-hayda-30",
    //                         "name": "Ya Em Dafayer",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/hayda-7aki/Ya_Em_Dafayer.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //
    //                     }
    //                 ]
    //         },
    //         {
    //             "id": "arab-enter-heik",
    //             "name": "Heik Men3'ani",
    //             "desc": "MTV redefines singing competitions with this new show featuring contestants trying to remember the lyrics to popular songs through various games. Hosted by Maya Diab.",
    //             "preview": "./img/movies/arabic-entertainment/Heik-Men3'ani.jpg",
    //             "videoUrl": "",
    //             "duration": 1,
    //             "categoryId": 7,
    //             "subCategory":
    //                 [
    //                     {
    //                         "id": "arab-enter-heik-1",
    //                         "name": "3ajabtini",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/3ajabtini.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-2",
    //                         "name": "3allem Waladak",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/3allem_Waladak.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-3",
    //                         "name": "3ataki 3omro",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/3ataki_3omro.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-4",
    //                         "name": "3azzetni El Deni",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/3azzetni_El_Deni.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-5",
    //                         "name": "3youn Bahiyya",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/3youn_Bahiyya.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-6",
    //                         "name": "7abayt 3younak",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/7abayt_3younak.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-7",
    //                         "name": "7aji Matar",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/7aji_Matar.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-8",
    //                         "name": "7asibak",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/7asibak.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-9",
    //                         "name": "7ekyou 3enayk",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/7ekyou_3enayk.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-10",
    //                         "name": "Ahla Gharam",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Ahla_Gharam.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-11",
    //                         "name": "Ahla Lebnaniye",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Ahla_Lebnaniye.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-12",
    //                         "name": "Ahlik Ma Baddoun Yani",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Ahlik_Ma_Baddoun_Yani.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-13",
    //                         "name": "Al Kamar Al Sina3i",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/al_kamar_al_sina3i.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-14",
    //                         "name": "Alawa",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Alawa.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-15",
    //                         "name": "Allah Ma3ak",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Allah_Ma3ak.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-16",
    //                         "name": "Allah Shou B7ebak",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Allah_Shou_B7ebak.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-17",
    //                         "name": "Ashouf Fik Youm",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Ashouf_Fik_Youm.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-18",
    //                         "name": "Assem Shar2i Baladi",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Assem_Shar2i_Baladi.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-19",
    //                         "name": "Ba7ebak",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Ba7ebak.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-20",
    //                         "name": "Bawastik",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Bawastik.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-21",
    //                         "name": "Bez3al Menak",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Bez3al_Menak.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-22",
    //                         "name": "Bfakker Fik",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Bfakker_Fik.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-23",
    //                         "name": "Bourdayik Ya Bordana",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Bourdayik_Ya_Bordana.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-24",
    //                         "name": "Bto2mor 3al Rass w 3al 3ayn",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/bto2mor_3al_rass_w_3al_3ayn.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-25",
    //                         "name": "Byeb3at Allah",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Byeb3at_Allah.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-26",
    //                         "name": "Byeb3at Allah Kbir",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Byeb3at_Allah_Kbir.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-27",
    //                         "name": "Chou Ba3melik",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/chou_ba3melik.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-28",
    //                         "name": "Dakhel El Ghannouj",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Dakhel_El_Ghannouj.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-29",
    //                         "name": "Ento Al Banat",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Ento_Al_Banat.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-heik-30",
    //                         "name": "Enzel Ya Gamil",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/heik-men3-ani/Enzel_Ya_Gamil.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //
    //                 ]
    //         },
    //         {
    //             "id": "arab-enter-kifni",
    //             "name": "Kifni Ma3ak",
    //             "desc": "Michel Ashi does it again, this time funnier than ever! Candid camera, tricks, twisted interviews, hilarious Vox pop. Expect the best of the worst with a complete new series.",
    //             "preview": "./img/movies/arabic-entertainment/kifne-ma3ak.jpg",
    //             "videoUrl": "",
    //             "duration": 1,
    //             "categoryId": 7,
    //             "subCategory":
    //                 [
    //                     {
    //                         "id": "arab-enter-kifni-1",
    //                         "name": "Kifne Ma3ak - 3am Yekhod Cadeaux 01",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_3am_yekhod_cadeaux01.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-2",
    //                         "name": "Kifne Ma3ak - 3am Yekhod Cadeaux 02",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_3am_yekhod_cadeaux02.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-3",
    //                         "name": "Kifne Ma3ak - 3am Yekhod Cadeaux 02",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_3am_yekhod_cadeaux2.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-4",
    //                         "name": "Kifne Ma3ak - 7ake Bati 201",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_7ake_bati201.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-5",
    //                         "name": "Kifne Ma3ak - 7ake Bati 202",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_7ake_bati202.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-6",
    //                         "name": "Kifne Ma3ak - 7arame 01",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_7arame01.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-7",
    //                         "name": "Kifne Ma3ak - 7arame 02",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_7arame02.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-8",
    //                         "name": "Kifne Ma3ak - Andaf Zalame",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_andaf_zalame.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-9",
    //                         "name": "Kifne Ma3ak - Aya Ma3loumet 01",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_aya_ma3loumet01.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-10",
    //                         "name": "Kifne Ma3ak - Aya Ma3loumet 02",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_aya_ma3loumet02.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-11",
    //                         "name": "Kifne Ma3ak - Bakil Sobato",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_bakil_sobato.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-12",
    //                         "name": "Kifne Ma3ak - Best Name",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_best_name.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-13",
    //                         "name": "Kifne Ma3ak - Betheb Nemzah Ma3ak",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_betheb_nemzah_ma3ak.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-14",
    //                         "name": "Kifne Ma3ak - Bonjour",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_bonjour.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-15",
    //                         "name": "Kifne Ma3ak - Boxe 01",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_boxe01.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-16",
    //                         "name": "Kifne Ma3ak - Boxe 02",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_boxe02.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-17",
    //                         "name": "Kifne Ma3ak - Chi M3alla2 Khayt",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_chi_m3alla2_khayt.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-18",
    //                         "name": "Kifne Ma3ak - Chips 01",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_chips01.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-19",
    //                         "name": "Kifne Ma3ak - Chips 02",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_chips02.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-kifni-20",
    //                         "name": "Kifne Ma3ak - Chlite",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/kifne-ma3ak/kifne_ma3ak_chlite.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                 ]
    //         },
    //         {
    //             "id": "arab-enter-dwts",
    //             "name": "Dancing with the Stars",
    //             "desc": "Enjoy even more sizzling salsas, sambas and spray-tans as a brand-new cast vies for the coveted Mirror ball Trophy on Dancing with the Stars returns for Season 25! Tom Bergeron and Erin Andrews are back to guide us through this exciting new season along with your favourite judges. Of course, it's still all about the fans who ultimately help determine which teams make the cut each week with their votes during the biggest dance party on the planet!",
    //             "preview": "./img/movies/arabic-entertainment/dancing-with-the-star.jpg",
    //             "videoUrl": "",
    //             "duration": 1,
    //             "categoryId": 7,
    //             "subCategory":
    //                 [
    //                     {
    //                         "id": "arab-enter-dwts-1",
    //                         "name": "DWTS - Chacha Amina Achraf",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_chacha-amina-achraf.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-2",
    //                         "name": "DWTS - Chacha Dalida Khalil",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_chacha-dalida-khalil.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-3",
    //                         "name": "DWTS - Chacha Jane Konsol",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_chacha-jane-konsol.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-4",
    //                         "name": "DWTS - Chacha Jean Paul Bitar",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_chacha-jean-paul-bitar.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-5",
    //                         "name": "DWTS - Foxtrot Anthony Touma",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_foxtrot-anthony-touma.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-6",
    //                         "name": "DWTS - Foxtrot Mohamed Attieh",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_foxtrot-mohamed-attieh.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-7",
    //                         "name": "DWTS - Salsa Anthony Touma",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_salsa-anthony-touma.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-8",
    //                         "name": "DWTS - Salsa Mohamed Attieh",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_salsa-mohamed-attieh.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-9",
    //                         "name": "DWTS - Salsa Rony Fahed",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_salsa-rony-fahed.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-10",
    //                         "name": "DWTS - Tango Carmen Lebbos",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_tango-carmen-lebbos.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-11",
    //                         "name": "DWTS - Tango Leila Ben Khalifa",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_tango-leila-ben-khalifa.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-12",
    //                         "name": "DWTS - Tango Reine Achkar",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_tango-reine-achkar.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-13",
    //                         "name": "DWTS - Tango Rima-Fakih",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_tango-rima-fakih.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-14",
    //                         "name": "DWTS - Waltz Gabriel Yammine",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_waltz-gabriel-yammine.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-dwts-15",
    //                         "name": "DWTS - Waltz Ibrahim Said",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/dwts/dwts_s3_waltz-ibrahim-said.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                 ]
    //         },
    //         {
    //             "id": "arab-enter-i-woman",
    //             "name": "I am a woman",
    //             "desc": null,
    //             "preview": "./img/movies/arabic-entertainment/I-Am-Woman.jpg",
    //             "videoUrl": "",
    //             "duration": 1,
    //             "categoryId": 7,
    //             "subCategory":
    //                 [
    //                     {
    //                         "id": "arab-enter-i-woman-1",
    //                         "name": "Define Me 1",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Define_me_1.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-2",
    //                         "name": "Define Me 2",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Define_me_2.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-3",
    //                         "name": "Define Me 3",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Define_me_3.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-4",
    //                         "name": "Define Me - Nutrition 1",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Define_me_nutrition_1.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-5",
    //                         "name": "Define Me - Nutrition 2",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Define_me_nutrition_2.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-6",
    //                         "name": "Define Me - Nutrition 3",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Define_me_nutrition_3.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-7",
    //                         "name": "Glam Me Up Jennifer Lopez 6",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Glam_me_up_Jennifer_Lopez_6.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-8",
    //                         "name": "Glam Me Up Kelly Osbourne 3",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Glam_me_up_Kelly_Osbourne_3.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-9",
    //                         "name": "Glam Me Up Kim Kardashian 1",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Glam_me_up_kim_kardashian_1.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-10",
    //                         "name": "Men Stripped 1",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Men_stripped_1.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-11",
    //                         "name": "Men Stripped 2",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Men_stripped_2.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-12",
    //                         "name": "Men Stripped 3",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Men_stripped_3.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-13",
    //                         "name": "Out There 1",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Out_there_1.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-14",
    //                         "name": "Out There 2",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Out_there_2.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-i-woman-15",
    //                         "name": "Out There 3",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/i-am-woman/Out_there_3.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                 ]
    //         },
    //         {
    //             "id": "arab-enter-jamaluki",
    //             "name": "Jamaluki m3 dima",
    //             "desc": "The best Arabic beauty trends with Dima, enjoy exploring the tips and tricks right on your mobile.",
    //             "preview": "./img/movies/arabic-entertainment/Jamaloki-M3-Dima.jpg",
    //             "videoUrl": "",
    //             "duration": 1,
    //             "categoryId": 7,
    //             "subCategory":
    //                 [
    //                     {
    //                         "id": "arab-enter-jamaluki-1",
    //                         "name": "Classy Smoky Look",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Classy-smoky-look.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-2",
    //                         "name": "Concealer",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Concealer.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-3",
    //                         "name": "Contouring Techniques",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Contouring-techniques.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-4",
    //                         "name": "Cream Foundation",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Cream-foundation.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-5",
    //                         "name": "Daily Make Up (Gray)",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Daily-make-up-(gray).jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-6",
    //                         "name": "Daily Make Up (Pink)",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Daily-make-up-(pink).jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-7",
    //                         "name": "Daily Make Up (Violet)",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Daily-make-up-(violet).jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-8",
    //                         "name": "Daily Make Up",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Daily-make-up.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-9",
    //                         "name": "Friday Hangout With Friends",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Friday-hangout-with-friends.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-10",
    //                         "name": "How To Clean Your Fake Eyelashes",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/How-to-clean-your-fake-eyelashes.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-11",
    //                         "name": "How To Make Up On Your Graduation Day",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/How-to-make-up-on-your-graduation-day.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-12",
    //                         "name": "How To Make Your Eyes Look Bigger",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/How-to-make-your-eyes-look-bigger.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-13",
    //                         "name": "How To Put Eyeliner Perfectly",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/How-to-put-eyeliner-perfectly.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-14",
    //                         "name": "How To Put Fake Eyelashes",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/How-to-put-fake-eyelashes.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-15",
    //                         "name": "Lining Your Eyes",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/lining-your-eyes.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-16",
    //                         "name": "Look Great On Your Birthday",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Look-great-on-your-birthday.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-17",
    //                         "name": "Magnificient Evening Make Up",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Magnificient-evening-make-upv.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-18",
    //                         "name": "Quick & Easy Eyebrow",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Quick-&-easy-eyebrow.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-19",
    //                         "name": "Quick Make Up For Work",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Quick-make-up-for-work.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-20",
    //                         "name": "Smoky Evening Make Up",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Smoky-evening-makeup.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-21",
    //                         "name": "Soft & Easy Make Up",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Soft-&-easy-make-up.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-22",
    //                         "name": "Soft Evening Make Up",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Soft-evening-make-up.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-23",
    //                         "name": "Spring & Summer Look",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Spring-&-summer-look.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-24",
    //                         "name": "Using Black Eyeliner",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Using-black-eyeliner.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-jamaluki-25",
    //                         "name": "Wearing Red Lipstick",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/jamaloki-m3-dima/Wearing-red-lipstick.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                 ]
    //         },
    //         {
    //             "id": "arab-enter-mariam-advice",
    //             "name": "Mariam Advice",
    //             "desc": "The best Arabic beauty trends with Mariam, enjoy exploring the tips and tricks right on your mobile.",
    //             "preview": "./img/movies/arabic-entertainment/Mariam-Advice.jpg",
    //             "videoUrl": "",
    //             "duration": 1,
    //             "categoryId": 7,
    //             "subCategory":
    //                 [
    //                     {
    //                         "id": "arab-enter-mariam-advice-1",
    //                         "name": "Nasayeh Maria - 3amaliyat Chad Al Bachara",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria---3AMALIYAT-CHAD-AL-BACHARA.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advice-2",
    //                         "name": "Nasayeh Maria - Al Azafer",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria---AL-AZAFER.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advice-3",
    //                         "name": "Nasayeh Maria - Al Bachara Al 7assasa",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria---AL-BACHARA-AL-7ASSASA.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advic-4",
    //                         "name": "Nasayeh Maria - Al Bachara Al Jafa",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria---AL-BACHARA-AL-JAFA.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advice-5",
    //                         "name": "Nasayeh Maria - Al Bachara Al Zouhniya",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria---AL-BACHARA-AL-ZOUHNIYA.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advice-6",
    //                         "name": "Nasayeh Maria - Beauty Products",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria--Beauty-Products.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advice-7",
    //                         "name": "Nasayeh Maria - Blackheads",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria--Blackheads.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advice-8",
    //                         "name": "Nasayeh Maria - Cucumber & Beauty",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria--Cucumber-&-Beauty.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advice-9",
    //                         "name": "Nasayeh Maria - Eyes & Neck Care",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria--Eyes-&-Neck-Care.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advice-10",
    //                         "name": "Nasayeh Maria - Facial",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria--Facial.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advice-11",
    //                         "name": "Nasayeh Maria - Feet Care",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria--Feet-Care.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advice-12",
    //                         "name": "Nasayeh Maria - Oily Skin",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria--Oily-Skin.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advice-13",
    //                         "name": "Nasayeh Maria - Solarium",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria--Solarium.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advice-14",
    //                         "name": "Nasayeh Maria - Taches Brunes",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria--Taches-Brunes.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-mariam-advice-15",
    //                         "name": "Nasayeh Maria - Taches Seniles",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/mariam-advice/Nasayeh-Maria--Taches-Seniles.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                 ]
    //         },
    //         {
    //             "id": "arab-enter-shine",
    //             "name": "Shine with Mariam",
    //             "desc": "Enjoy The best Arabic beauty trends with Mariam, enjoy exploring the tips and tricks right on your mobile.",
    //             "preview": "./img/movies/arabic-entertainment/shine-with-mariam.jpg",
    //             "videoUrl": "",
    //             "duration": 1,
    //             "categoryId": 7,
    //             "subCategory":
    //                 [
    //                     {
    //                         "id": "arab-enter-shine-1",
    //                         "name": "3abeye",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/3abeye.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-2",
    //                         "name": "Ahmar Al Chifah",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/AHMAR-AL-CHIFAH-.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-3",
    //                         "name": "Al Alwan",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/AL-ALWAN.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-4",
    //                         "name": "Al Anaka",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/AL-ANAKA.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-5",
    //                         "name": "Al Khasr Al 3ali",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/AL-KHASR-AL-3ALI.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-6",
    //                         "name": "Al Lawn Il-Abyad",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/AL-LAWN-IL-ABYAD.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-7",
    //                         "name": "Al Malabes Al Asesiye Lil 3AMAL",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/AL-MALABES-AL-ASESIYE-LIL-3AMAL.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-8",
    //                         "name": "Al Tannoura Al Tawile",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/AL-TANNOURA-AL-TAWILE.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-9",
    //                         "name": "Alwan Kaws Al Kousah",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/ALWAN-KAWS-AL-KOUSAH.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-10",
    //                         "name": "Azya2 Al Tamannat",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/AZYA2-AL-TAMANNAT.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-11",
    //                         "name": "Broche",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/broche.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-12",
    //                         "name": "Cha3rouki Yawm Zafafouki",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/CHA3ROUKI-YAWM-ZAFAFOUKI.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-13",
    //                         "name": "Fasatin Al A3rass",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/FASATIN-AL-A3RASS.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-14",
    //                         "name": "Floral Prints",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/FLORAL-PRINTS.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                     {
    //                         "id": "arab-enter-shine-15",
    //                         "name": "Houdoum Fasl Il sayf",
    //                         "desc": "",
    //                         "preview": " ./img/thumbnails/shine-with-mariam/HOUDOUM-FASL-IL-SAYF.jpg",
    //                         "videoUrl": "",
    //                         "duration": 1,
    //                     },
    //                 ]
    //         }
    //     ]
    //
    // },
    // {
    //     "id" : 3,
    //     "contents" : 3,
    //     "name" : "American TV Series",
    //     "videos" : [
    //         {
    //             "duration" : 1800,
    //             "id" : 31,
    //             "name" : "Flashpoint | CBS US",
    //             "preview" : "./img/movies/american-tv-series/flashpoint.jpeg",
    //             "desc" : "When the Strategic Response Unit arrives, the rules change. The bad guy's caught - he just doesn't know it yet. The SRU, inspired by Toronto's Emergency Task Force, is a handpicked team of elite cops. High risk is their business and these men and women do it all: rescue hostages, bust gangs, defuse bombs. Talk down suicidal teens. Protect the Pope. They handle state-of-the-art weapons - sniper rifles, flash-bang grenades, tasers. They climb the sides of buildings. See through walls. But"
    //         },
    //         {
    //             "duration" : 3600,
    //             "id" : 32,
    //             "name" : "Hemlock Grove",
    //             "preview" : "./img/movies/american-tv-series/hemlock.jpeg",
    //             "desc" : "A teenage girl is brutally murdered, sparking a hunt for her killer. But in a town where everyone hides a secret, will they find the monster among them?"
    //         },
    //         {
    //             "duration" : 3600,
    //             "id" : 33,
    //             "name" : "Hannibal",
    //             "preview" : "./img/movies/american-tv-series/hannibal.jpeg",
    //             "desc" : "Explores the early relationship between the renowned psychiatrist and his patient, a young FBI criminal profiler, who is haunted by his ability to empathize with serial killers."
    //         }
    //     ]
    // },
    {
        "id" : 4,
        "contents" : 4,
        "name" : "Hollywood Blockbusters",
        "videos" : [
            {
                "duration" : "Watch Now",
                "id" : 202,
                "name" : "Dark Touch",
                "preview" : "./img/movies/hollywood-blockbusters/dark-touch.jpeg",
                "desc" : "An isolated country house takes on a monstrous life of its own. Objects and furniture attack the inhabitants, leaving 11-year-old Niamh the only survivor of a bloody massacre that destroys her parents and her little brother, Ciaran. The police ignore her when she tries to tell them about the murderous rage of the house. She is taken in by family friends who try to give her some semblance of a normal life. But Niamh cannot find peace. All around her, signs of danger continue to"
            },
            {
                "duration" : 45223,
                "id" : 203,
                "name" : "Airborne",
                "preview" : "./img/movies/hollywood-blockbusters/Airborne.jpg",
                "desc" : "A plane takes off during a snowstorm and soon reports both pilots are dead. As the passengers slowly die off, they wish they had never left the ground."
            },
            {
                "duration" : 33213,
                "id" : 204,
                "name" : "The Broken",
                "preview" : "./img/movies/hollywood-blockbusters/the-broken.jpeg",
                "desc" : "A woman is thrust into a world where everything is subtly unfamiliar in this edgy thriller from writer and director Sean Ellis. Gina McVay (Lena Headey) is a radiologist who is enjoying dinner one evening with her family and her boyfriend Stefan (Melvil Poupaud) when a mirror shatters for no apparent reason. After a few moments, no one thinks much of it, but the next day Gina is leaving work and she sees something even more troubling -- a woman who looks just like her, driving a car identical to her own. Curious, Gina sneaks into the doppelganger's apartment and sees a photo of herself and her father in the hallway. Seriously rattled, Gina runs out and drives away, only to get in an accident that lands her in the hospital. After she's released, Gina asks Stefan if she can stay with him, but while he looks the same, his personality and behavior are quite different from the way she remembers him, and she begins having vivid nightmares which become all the more terrifying when the same horrific images begin popping up in her waking hours. The Broken received its American premiere at the 2008 Sundance Film Festival."
            },
            {
                "duration" : 31344,
                "id" : 205,
                "name" : "The History of Love",
                "preview" : "./img/movies/hollywood-blockbusters/The-History-of-love.jpg",
                "desc" : "What if a book written before World War II in a little village in Eastern Europe could shine through the years, crossing continents and surviving violent conflicts, to guide the journey of three generations? This book is entitled THE HISTORY OF LOVE. New York, the 21st century. Leo, an old Polish Jewish immigrant, lives with the memory of the great love of his life. Despite his painful history, he cheerfully navigates life’s ups and downs with indefatigable, crazy humour, alongside his"
            },
            {
                "duration" : 31344,
                "id" : 206,
                "name" : "One Last Breath",
                "preview" : "./img/movies/hollywood-blockbusters/One-Last-Breath.jpg",
                "desc" : "Year's after suspicious circumstances claim the life of her mother, young Alex Hart decides to take matters into her own hands to learn the truth about her father Raymond. Her quest leads her into the terrifying conspiracy of a pharmaceutical giant and it's CEO who's hiding the fact that Raymond is being tortured by an experimental new treatment deep inside the walls of the company"
            },
            // {
            //     "duration" : 31344,
            //     "id" : "holly-block-1"
            //     "name" : "Fourth Angel",
            //     "preview" : "./img/movies/hollywood-blockbusters/Fourth-Angel.jpg",
            //     "desc" : "Jack Elgin is a magazine editor who surprises his wife and three kids with a vacation to India. While their plane is refuelling in Cyprus, the Elgin's jetliner is suddenly taken over by terrorists. All hell breaks loose and Jack's wife and two daughters are killed. Back in London, Jack comforts his traumatized young son and tries to make sense of this tragedy, but is further horrified when the terrorists are released. When Jack decides to take justice in his own hands, he must"
            // },
            {
                "duration" : 31344,
                "id" : 207,
                "name" : "Riders (Steal)",
                "preview" : "./img/movies/hollywood-blockbusters/Riders.jpg",
                "desc" : "Slim, Otis, Frank and Alex (three boys and a girl) form a group of snowboard and skate young bank robbers. They are known as masters of the runaway art. Slim, the thinking head hatched a plan for their final retirement: five consecutive burglars, in five days, involving 20 million dollars. But this time, they're gonna have to face both the police - and the mafia!"
            },
            {
                "duration" : 31344,
                "id" : 208,
                "name" : "Under Suspicion",
                "preview" : "./img/movies/hollywood-blockbusters/Under-Suspicion.jpg",
                "desc" : "A lawyer is asked to come to the police station to clear up a few loose ends in his witness report of a foul murder. This will only take ten minutes, they say, but it turns out to be one loose end after another, and the ten minutes he is away from his speech become longer and longer..."
            },
            {
                "duration" : 31344,
                "id" : 209,
                "name" : "White Bird in a Blizzard",
                "preview" : "./img/movies/hollywood-blockbusters/White-Bird-in-a-Blizzard.jpg",
                "desc" : "Kat Connors is 17 years old when her perfect homemaker mother, Eve, a beautiful, enigmatic, and haunted woman, disappears - just as Kat is discovering and relishing her newfound sexuality. Having lived for so long in a stifled, emotionally repressed household, she barely registers her mother's absence and certainly doesn't blame her doormat of a father, Brock, for the loss. In fact, it's almost a relief. But as time passes, Kat begins to come to grips with how deeply Eve's"
            },
            {
                "duration" : 31344,
                "id" : 210,
                "name" : "The Revolt",
                "preview" : "./img/movies/hollywood-blockbusters/the-revolt.jpg",
                "desc" : "A nation that neglects its history is a nation with no past, with no memory, unable to learn from mistakes in times past and unable to benefit from the achievements and glorious acts of former generations.\""
            },
            {
                "duration" : 31344,
                "id" : 211,
                "name" : "Haunter",
                "preview" : "./img/movies/hollywood-blockbusters/Haunter.jpg",
                "desc" : "In this reverse ghost story, teenage Lisa Johnson (Breslin) and her family died in 1986 under sinister circumstances but remain trapped in their house, unable to move on. Over a period of six “days”, Lisa must reach out from beyond the grave to help her present-day, living counterpart, Olivia, avoid the same fate Lisa and her family suffered."
            },
            {
                "duration" : 31344,
                "id" : 212,
                "name" : "Maniac",
                "preview" : "./img/movies/hollywood-blockbusters/Maniac.jpg",
                "desc" : "Just when the streets seemed safe, a serial killer with a fetish for scalps is back and on the hunt. Frank is the withdrawn owner of a mannequin store, but his life changes when young artist Anna appears asking for his help with her new exhibition. As their friendship develops and Frank's obsession escalates, it becomes clear that she has unleashed a long-repressed"
            },
            {
                "duration" : 31344,
                "id" : 213,
                "name" : "3 Holiday Tails",
                "preview" : "./img/movies/hollywood-blockbusters/3-Holiday-Tails.jpg",
                "desc" : "Rod and Katherine Wright are enjoying their retirement in Florida – or so they’re telling each other. Actually, Rod’s been bored with nothing to do, and Katherine misses her kids back home, especially with Christmas right around the corner. At least they’ve made friends with their new neighbor Lisa, who’s a golden retriever fan like them – Rod and Katherine’s dog Jake has three new puppy playmates, Mario, Luigi and Pasquale. But when Jake and the puppies take off during a walk with"
            },
            {
                "duration" : 31344,
                "id" : 214,
                "name" : "Universal Soldier III: Regeneration ( A new beginning)",
                "preview" : "./img/movies/hollywood-blockbusters/Universal-Soldier-III-Regeneration.jpg",
                "desc" : "When terrorists threaten nuclear catastrophe, the world's only hope is to reactivate decommissioned Universal Soldier Luc Deveraux. Rearmed and reprogrammed, Deveraux must take on his nemesis from the original Universal Soldier and a next-generation \"UniSol"
            },
            {
                "duration" : 31344,
                "id" : 215,
                "name" : "Valhalla Rising",
                "preview" : "./img/movies/hollywood-blockbusters/Valhalla-Rising.jpg",
                "desc" : "1000 AD. For years, One Eye, a mute warrior of supernatural strength, has been held prisoner by the Norse chieftain Barde. Aided by Are, a boy slave, One Eye slays his captor and together he and Are escape, beginning a journey into the heart of darkness."
            },
            {
                "duration" : 31344,
                "id" : 216,
                "name" : "The Good Girl",
                "preview" : "./img/movies/hollywood-blockbusters/the-good-girl.jpg",
                "desc" : "The plot revolves around a young married woman whose mundane life takes a turn for the worse when she strikes up a passionate and illicit affair with an oddball discount-store stock boy who thinks he's Holden Caulfield."
            },
            {
                "duration" : 31344,
                "id" : 217,
                "name" : "The Dealiest Sea",
                "preview" : "./img/movies/hollywood-blockbusters/deadliest-sea.jpg",
                "desc" : "Based on a true story of a fishing boat out of Kodiak, Alaska that encountered a storm and was hit by a rogue wave. The crew, believing that their vessel was about to capsize, abandoned ship in the Bering sea."
            },
        ]
    },
    // {
    //     "id" : 3,
    //     "contents" : 5,
    //     "name" : "International Movies",
    //     "videos" : [
    //         {
    //             "duration" : 28330,
    //             "id" : 21,
    //             "name" : "The Last Days",
    //             "preview" : "./img/movies/international-movies/the-last-days.jpeg",
    //             "desc" : "2013. A mysterious epidemic spreads across the planet. Humanity develops an irrational fear of open spaces that leads to instant death. Soon, the world's remaining population is trapped inside buildings. As Barcelona descends into chaos, Marc embarks on a quest to find Julia, his missing girlfriend, without ever setting foot outside."
    //         },
    //         {
    //             "duration" : 37212,
    //             "id" : 22,
    //             "name" : "The Good Neighbor",
    //             "preview" : "./img/movies/international-movies/the-good-neightbor.jpeg",
    //             "desc" : "2013. A mysterious epidemic spreads across the planet. Humanity develops an irrational fear of open spaces that leads to instant death. Soon, the world's remaining population is trapped inside buildings. As Barcelona descends into chaos, Marc embarks on a quest to find Julia, his missing girlfriend, without ever setting foot outside."
    //         },
    //         {
    //             "duration" : 38240,
    //             "id" : 23,
    //             "name" : "Graduation aka Bacalaureat",
    //             "preview" : "./img/movies/international-movies/graduation.jpeg",
    //             "desc" : "Romeo Aldea (49), a physician living in a small mountain town in Transylvania, has raised his daughter Eliza with the idea that once she turns 18, she will leave to study and live abroad. His plan is close to succeeding -•Eliza has won a scholarship to study psychology in the UK. She just has to pass her final exams – a formality for such a good"
    //         },
    //         {
    //             "duration" : 38240,
    //             "id" : 24,
    //             "name" : "Colt 45",
    //             "preview" : "./img/movies/international-movies/colt-45.jpeg",
    //             "desc" : "Police armourer and firearms instructor Vincent Milès is a shooting ace. Only 25 years old, his prowess is the envy of the world's finest but, to the incomprehension of his colleagues, Vincent refuses to join the police action units. Trapped in a situation primed to blow sky high, Vincent is left with no choice but to embrace the darkness within him if"
    //         },
    //         {
    //             "duration" : 38240,
    //             "id" : 25,
    //             "name" : "Hierro",
    //             "preview" : "./img/movies/international-movies/hierro.jpeg",
    //             "desc" : "After her son goes missing, a broken mother returns months later to the island of El Hierro to identify a body. She finds out her son is not the only one missing."
    //         }
    //     ]
    // },
    {
        "id" : 5,
        "contents" : 9,
        "name" : "Bollywood Movies",
        "videos" : [
            {
                "duration" : 10841,
                "id" : 218,
                "name" : "1920 - London",
                "preview" : "./img/movies/bollywood-movies/1920-london.jpeg",
                "desc" : "Shivangi lives happily in London with her husband Veer. On witnessing Veer's strange behavior one day, she discovers that an evil spirit has possessed him and seeks help from an exorcist."
            },
            {
                "duration" : 10740,
                "id" : 219,
                "name" : "Bodyguard",
                "preview" : "./img/movies/bollywood-movies/bodyguard.jpeg",
                "desc" : "Lovely Singh is extremely respectful of Mr. Rana and his daughter Divya. While appointed as Divya's bodyguard, he falls in love with a girl he has never met, unaware that she is none other than Divya."
            },
            {
                "duration" : 11020,
                "id" : 220,
                "name" : "Commando 2",
                "preview" : "./img/movies/bollywood-movies/commando-2.jpeg",
                "desc" : "Commando 2 traces a black money trail as Karan (Vidyut Jammwal) a commando, cops Bakhtawar (Freddy Daruwala) and Bhawna Reddy (Adah Sharma) are assigned to arrest Vicky Chadha (Thakur Anoop Singh) and international money launderer in Thailand. While Karan and Bakhtawar don’t see eye to eye, Bhawna’s too stupid to lead a mission. A major twist in tale comes when Vicky’s wife Maria (Esha Gupta) claims that she and Vicky are innocent. There’s double crossing, love affairs and a much bigger truth yet to unfold. Will Karan succeed in his mission is what is left to see"
            },
            {
                "duration" : 11055,
                "id" : 221,
                "name" : "Ghayal Once Again",
                "preview" : "./img/movies/bollywood-movies/ghayal-once-again.jpeg",
                "desc" : "When a video of his mentor's murder surfaces, an investigative journalist (Sunny Deol) takes action to find the killers."
            },
            {
                "duration" : 10800,
                "id" : 222,
                "name" : "Golmaal Again",
                "preview" : "./img/movies/bollywood-movies/golmaal-again.jpeg",
                "desc" : "GOLMAAL AGAIN is the story of five friends who encounter strange occurrences when they visit their orphanage. Gopal (Ajay Devgn), Madhav (Arshad Warsi), Lucky (Tusshar Kapoor), Laxman Prasad Apte (Shreyas Talpade) and Laxman Sharma (Kunal Kemmu) are orphans who grew up in an orphanage owned by Jamnadas (Uday Tikekar). As kids, they were close to each other but then they became rivals. Gopal and Laxman Prasad Apte separated while Madhav, Lucky and Laxman Sharma went their own way. When they all grew up, they start working with land sharks and their job revolved around getting the plots vacated. This also created further friction among them. But when they learn that Jamnadas has passed away, they decide to iron out their differences and go together to the orphanage to pay their respects. They stay at Colonel Chouhan’s (Sachin Khedekar) bungalow located right next to Jamnadas Orphanage, where their childhood friend Anna (Tabu) is also residing. Anna has a special power – she can communicate with the dead. At the Colonel’s bungalow, Gopal gets attracted to the caretaker Damini (Parineeti Chopra). Meanwhile, Vasu Reddy (Prakash Raj), a builder and a close friend of Jamnadas announces that Jamnadas gave away the land to him where the orphanage is situated. He also says that he has decided to shift the kids at Bengaluru where he’ll provide them with better facilities. Gopal is ghost-fearing person and he starts to see the spirit of Jamnadas’s dead daughter (Ashwini Kalsekar). However, the truth is something else and when the five friends find out, it shocks them like never before. What is that truth and what happens next forms the rest of the film."
            },
            {
                "duration" : 17845,
                "id" : 223,
                "name" : "Holiday",
                "preview" : "./img/movies/bollywood-movies/holiday.jpeg",
                "desc" : "After a bomb destroys the bus on which he was riding, a military officer (Akshay Kumar) foregoes his vacation to hunt down a terrorist and the sleeper cells under his command."
            },
            {
                "duration" : 17845,
                "id" : 224,
                "name" : "Naam Shabana",
                "preview" : "./img/movies/bollywood-movies/naam-shabana.jpeg",
                "desc" : "This Spin-off from Baby (2015) provides the back-story of intelligence agent Shabana, and chronicles how she becomes a spy."
            },
            {
                "duration" : 17845,
                "id" : 225,
                "name" : "Singham Returns",
                "preview" : "./img/movies/bollywood-movies/singham-returns.jpeg",
                "desc" : "Singham returns as the brave and honest policeman who only resorts to force when necessary."
            },
            {
                "duration" : 17845,
                "id" : 226,
                "name" : "Wazir",
                "preview" : "./img/movies/bollywood-movies/wazir.jpeg",
                "desc" : "A brave ATS officer (Farhan Akhtar) and a disabled grandmaster (Amitabh Bachchan) face a mysterious and dangerous opponent (Neil Nitin Mukesh)."
            }
        ]
    },


];


// WEBPACK FOOTER //
// ./src/constants/safarimovies.js